<template lang="pug">
.dropdown.table-actions-dropdown.pull-right
  a.btn.btn-sm.btn-default.dropdown-toggle(
    href="#"
    data-toggle="dropdown"
    role="button"
  )
    | Actions
    i.hi.hi-caret.hi-10
  ul.dropdown-menu.dropdown-menu-right
    template(v-if="isNativeProject")
      li(v-if="taskIsActive")
        a(
          :class="actionClasses(task.can_update)"
          :title="actionTitle('edit', task.can_update)"
        )
          | Edit
      li
        a(
          v-if="taskIsActive"
          :class="actionClasses(task.can_complete)"
          :title="actionTitle('complete', task.can_complete)"
        )
          | Mark as complete
        a(
          v-else
          :class="actionClasses(task.can_manage)"
          :title="actionTitle('re-open', task.can_manage)"
        )
          | Re-open
      li
        a(
          :class="actionClasses(task.can_delete)"
          :title="actionTitle('delete', task.can_delete)"
        )
          | Delete
    li(v-else)
      a.action.blank-link(
        href="#"
        target="_blank"
      )
        | View
</template>

<script>
import { mapGetters } from 'vuex';
import { upperFirst, lowerCase } from 'lodash-es';

export default {
  name: 'TasksListActions',
  props: {
    task: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['isNativeProject']),
    taskIsActive() {
      return lowerCase(this.task.status) === 'active';
    },
  },
  methods: {
    actionClasses(hasPermission) {
      const base = 'action a-tooltip';

      return hasPermission ? `${base} action-dialog blank-link` : `${base} section-disabled`;
    },
    actionTitle(action, hasPermission) {
      const base = `${action} this to-do`;

      return hasPermission ? upperFirst(base) : `You don't have permission to ${base}`;
    },
  },
};
</script>
